import React from "react";
import SwiperCore, { Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import { templateActions } from "@pages/Applications/C&C/C&CSetup/templateStore";

import { MediaDisplay } from "../MediaDisplay";

import "swiper/swiper.min.css";

SwiperCore.use([Autoplay]);

export function BannerPreview({ deviceType, section }: any): JSX.Element {
    const path = ["template", "SiteWeb", "LaindingPage", section, deviceType];
    const localData: any = templateActions.getNestedObject(path);

    const template = localData
        ? Array.isArray(localData)
            ? [...localData]
            : [localData]
        : [];
    const activeScreens = template.filter((item: any) => item.active !== false);

    return (
        <div
            className="mt-2"
            style={{
                height: "100%",
                maxHeight: section === "Bannier" ? "50vh" : "100%",
                overflow: "hidden",
            }}
        >
            {activeScreens.length > 1 ? (
                <Swiper
                    onSlideChange={(swiper) => {
                        const currentSlide = swiper.slides[swiper.activeIndex];
                        const video = currentSlide.querySelector(
                            "video"
                        ) as HTMLVideoElement;
                        if (video) {
                            swiper.autoplay.stop();
                            video.currentTime = 0;
                            video.play().then(() => {
                                video.onended = () => {
                                    swiper.slideNext();
                                    swiper.autoplay.start();
                                };
                            });
                        } else {
                            swiper.autoplay.start();
                        }
                    }}
                    style={{ height: "100%" }}
                >
                    {activeScreens.map((item: any) => (
                        <SwiperSlide
                            key={item.id || item.Url}
                            style={{ height: "100%" }}
                        >
                            <MediaDisplay item={item} section={section} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            ) : (
                <div style={{ height: "100%" }}>
                    {activeScreens.map((item: any) => (
                        <MediaDisplay
                            key={item.id || item.Url}
                            item={item}
                            section={section}
                        />
                    ))}
                </div>
            )}
        </div>
    );
}
